// IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов)
// Причина: при store.fetchMode 'by_ids' словарь сегмента (store.itemsSource[seg]) держит только id, которые уже пришли со страницей.
// Открытие списка подбора ссылки (AttrGrid.dropdown_setItems — один путь и для обычного грида, и для AttrTabGrid формы)
// ищет только по этому кэшу; серверный поиск (async_name_search) запускается лишь от ввода ≥ 2 символов, полный список — по ☰.
// Замер DM (поле doc.params.prev_process_model, PROCESS-MODEL — 29 записей): список из одной ПМ, «ще варіантів: 0+».
// Решение: при открытии с пустым вводом — одна проба name_search без текста с limit = LINK_DROPDOWN_PROBE_LIMIT (потолок бэка
// name-search-limit-max = 100); вернулось меньше лимита — сегмент малый и весь в кэше: список показывает все записи, «+» снят.
// Большой сегмент (товары, склады): одна проба на сегмент за сеанс, дальше — прежнее поведение (10 пунктов, «… +», ☰).
// Выключатель — fe.ux.linkDropdownSmallAll (по умолчанию вкл).
export const LINK_DROPDOWN_PROBE_LIMIT = 100

// состояние пробы на объекте словаря сегмента: undefined — не было, null — в полёте, true — сегмент весь в кэше, false — большой
export function linkDropdown_shouldProbe({ on, searchText, isFormula, itemsSource }) {
    if (!on || isFormula || !itemsSource) return false
    if (itemsSource.fetchMode !== 'by_ids' || !itemsSource.segment) return false
    if (String(searchText ?? '').trim() !== '') return false
    return itemsSource._smallAll === undefined
}

export function linkDropdown_probeStart(itemsSource) {
    if (itemsSource) itemsSource._smallAll = null
}

// ответ пробы: newItems — строки name_search ('' → первые limit по названию, без архивных)
// IE 2026 10 28 / ODOO-5800 (p079b): answer с ошибкой бэка (замер dev02: PROCESS-MODEL, «ORDER BY position 0 is not in select list», data [])
// — не «малый сегмент», а прежнее поведение (большой: «+» и догрузка остаются)
export function linkDropdown_probeSettle(itemsSource, newItems, limit = LINK_DROPDOWN_PROBE_LIMIT, answer = null) {
    if (!itemsSource) return false
    if (answer && (answer.exception || answer.error || answer.status === 'error')) {
        itemsSource._smallAll = false
        return false
    }
    const n = Array.isArray(newItems) ? newItems.length : limit
    itemsSource._smallAll = n < limit
    return itemsSource._smallAll
}

export function linkDropdown_isComplete(itemsSource, on) {
    return !!on && itemsSource?._smallAll === true
}

// сколько пунктов показать: сегмент весь в кэше — все строки словаря, иначе прежний maxItems (0 — менять не нужно)
export function linkDropdown_fullMax(itemsSource, on, maxItems) {
    if (!linkDropdown_isComplete(itemsSource, on) || !Array.isArray(itemsSource.data)) return 0
    return itemsSource.data.length > maxItems ? itemsSource.data.length : 0
}
